import { configureStore } from "@reduxjs/toolkit";
import UserInfoSlice from "./Reducers/UserInfo/index";
import DropDownApplicationInformation from "./Reducers/DropDownApplicationInformation"; // Fixed typo
import DropDownItem from "./Reducers/AdvertisingAndMediaPlanForTheProject/DropDownForItems/index";
import AP_AdvertisingPlan from "./Reducers/TextAreaAdvertisingAndMediaPlan"; // Fixed typo

import VariousVariables from "./Reducers/VariousVariables";
import ApplicationInformation from "./Reducers/ApplicationInformation";
import PersonalInformation from "./Reducers/PersonalInformation";
import SecondarySectors from "./Reducers/SecondarySectors";
import FetchDataJson from "./Reducers/FetchDataJson";

import BeneficiaryInformation from "./Reducers/BeneficiaryInformation";
import GeneralInformation from "./Reducers/GeneralInformation";
import CoApplicantNames from "./Reducers/CoApplicantNames";

import ProjectInformation from "./Reducers/ProjectInformationPage/ProjectInformation";
import ExpectedProjectImpact from "./Reducers/ProjectInformationPage/ExpectedProjectTargetGroupModule";
import SectoreInformationProject from "./Reducers/ProjectInformationPage/SectoreInformationProject";
import ProjectPlanDetails from "./Reducers/ProjectInformationPage/ProjectPlanDetails";
import AdvertisingAndMediaPlanForTheProject from "./Reducers/AdvertisingAndMediaPlanForTheProject";
import TargetInfo from "./Reducers/ProjectInformationPage/InformationAboutTheTargetGroupOfTheProject/";
import OneAdvertisingAndMediaPlanForTheProject from "./Reducers/AdvertisingAndMediaPlanForTheProject/indexOne";

import Attachments from "./Reducers/Attachments";
import Acknowledgement from "./Reducers/Acknowledgement";
import ApplicationInformationValidationPage from "./Reducers/ApplicationInformationValidationPage";
import BI_TimelineInformation from "./Reducers/BudgetInformation/TimelineInformation";

import DropDownTargetedGroupAge from "./Reducers/ProjectInformationPage/InformationAboutTheTargetGroupOfTheProject/DropDownForTargetGroupAge";
import OneInformationAboutTheTargetGroupOfTheProject from "./Reducers/ProjectInformationPage/InformationAboutTheTargetGroupOfTheProject/indexOne";
import DropDownTETypeOfWork from "./Reducers/ProjectInformationPage/ProjectManagementTeamMembers/DropDownForTypeOfWork";
import DropDownTENatureOfWork from "./Reducers/ProjectInformationPage/ProjectManagementTeamMembers/DropDownForNatutralOfWork";
import TeamMembersPreviousExperiencePartnerships from "./Reducers/ProjectInformationPage/ProjectManagementTeamMembers";
import OneProjectManagementTeamMembers from "./Reducers/ProjectInformationPage/ProjectManagementTeamMembers/indexOne";
import OneExperienceSummary from "./Reducers/ProjectInformationPage/ExperienceSummary/indexOne";
import DropDownNatureOfSupport from "./Reducers/ProjectInformationPage/OtherProjectSupport/DropDownForNatutralOfWork/index";
import OneOtherProjectSupport from "./Reducers/ProjectInformationPage/OtherProjectSupport/indexOne";
import OneProjectTechnicalTeamMembers from "./Reducers/ProjectInformationPage/ProjectTechnicalTeamMembers/indexOne";
import DropDownTE_TT_TypeOfWork from "./Reducers/ProjectInformationPage/ProjectTechnicalTeamMembers/DropDownsProjectTechnicalTeamMembers/index";
import DropDownJordanianGovernoratesName from "./Reducers/ProjectInformationPage/InformationAboutTheTargetGroupOfTheProject/DropDowntJordanianGovernorates/index";
import DropDownPalestinianGovernoratesName from "./Reducers/ProjectInformationPage/InformationAboutTheTargetGroupOfTheProject/DropDowntPalestinianGovernorates/index";
import OnePalestinianGovernoratesProjectActivities from "./Reducers/ProjectInformationPage/InformationAboutTheTargetGroupOfTheProject/GetOnePalestinian/indexOne";
import OneJordanianGovernoratesProjectActivitiesData from "./Reducers/ProjectInformationPage/InformationAboutTheTargetGroupOfTheProject/GetOneJordanaian/indexOne";
import BudgetDetails from "./Reducers/BudgetInformation/BudgetDetails";

import ObjectivesReducer from "./Reducers/BudgetInformation/Objectives";

import ValidateAllPages from "./Reducers/ValiadateAllPages";

import ObjectivesActivitiesReducer from "./Reducers/BudgetInformation/ObjectivesActivities";
import DirectCostsReducer from "./Reducers/BudgetInformation/DirectCosts";

import AdministrativeCostsReducer from "./Reducers/BudgetInformation/AdministrativeCosts";

import ValidationBudgetreducer from "./Reducers/BudgetInformation/ValidationBudget";

import Login from "./Reducers/Login";
import TasksManager from "./Reducers/TasksManager";
import MarksManager from "./Reducers/MarksManager";
import YesNoManager from "./Reducers/YesNoManager";
import RecommendationEvaluationManager from "./Reducers/RecommendationEvaluationManager";
import FlowSubmitter from "./Reducers/FlowSubmitter/AddFlowSubmitter";
import OneComponentByFlow from "./Reducers/ComponentByFlow/index";
import ActionButtons from "./Reducers/ActionButtons/index";
import WorkFlowSteps from "./Reducers/WorkFlowSteps/index";
import AccountUserAssigning from "./Reducers/AccountUserAssignin/index";
import SubTaskFlow from "./Reducers/SubTaskFlow/index";
import HeaderTaskPageData from "./Reducers/HeaderTaskPageData/index";
import RoleByUserGuid from "./Reducers/RoleByUser/index";
import AllSubTaskByMain from "./Reducers/AllSubTaskByMain/index";
import StepsAction from "./Reducers/StepsAction";
import ValidationTasksManager from "./Reducers/ValidationTasksManager";
import JobOpportunitiesDuringProject from "./Reducers/ReportStage/JobOpportunitiesDuringProject/index";
import TypeOfJobOpportunityDropDown from "./Reducers/ReportStage/TypeOfJobOpportunityDropdown/index";
import OpportunitiesObtained from "./Reducers/ReportStage/OpportunitiesObtained";
import ChallengesEncounteredThatAffected from "./Reducers/ReportStage/ChallengesEncounteredThatAffected";
import SuccessStory from "./Reducers/ReportStage/SuccessStory/index";
import PR_CityDropDown from "./Reducers/ReportStage/CityDropdown/index";
import PR_TypeOfActivityDropDown from "./Reducers/ReportStage/TypeOfActivityDropDown/index";
import PR_AgeGroupDropDown from "./Reducers/ReportStage/AgeGroupDropDown/index";
import PR_NationalityDropDown from "./Reducers/ReportStage/NationalityDropDown/index";
import EventsActivitiesNextFlow from "./Reducers/ReportStage/EventsActivitiesNextFlow/index";
import EventsActivities from "./Reducers/ReportStage/EventsActivities";

import InformationAboutApplication from "./Reducers/ReportStage/InformationAboutApplication/index";
import GetReportByAppGuidReducers from "./Reducers/ReportStage/Report/index";
import Stages from "./Reducers/ReportStage/Stages/index";
import Objective from "./Reducers/ReportStage/Objective/index";

import ExpectedObjectivesForStage from "./Reducers/ReportStage/ExpectedObjectivesForStag";
import ValidateReportStage from "./Reducers/ReportStage/ValidateReportStage";
import LessonsLearned from "./Reducers/ReportStage/LessonsLearned";
import InformationSocialMedia from "./Reducers/ReportStage/InformationSocialMedia";
import InformationWebsite from "./Reducers/ReportStage/InformationWebsite";
import InformationApp from "./Reducers/ReportStage/InformationApp";


import WorkFlowReducer from './Reducers/ReportStage/WorkFlowReport/index'
import ExchangeInformationItemAdministrativeCostsReducer from './Reducers/ReportStage/ExchangeInformationItemAdministrativeCosts/index'
import PRAdministrativeCostsReducers from './Reducers/ReportStage/PRAdministrativeCosts/index'
import ExchangeDirectCostReducers from './Reducers/ReportStage/ExchangeDirectCost/index'
import ImplementationStagesAndActivitiesReducers from './Reducers/ReportStage/PR_DirectCosts/index'
import AdministrativeCostsComments from './Reducers/ReportStage/AdministrativeCostsComments/index'

// import WorkFlowReducer from "./Reducers/ReportStage/WorkFlowReport/index";

import TransferItemInformation from "./Reducers/ReportStage/TransferItemInformation";
import TransferDropDowns from "./Reducers/ReportStage/TransferDropDowns";

import TechnicalReportNotes from "./Reducers/ReportStage/TechnicalReportNotes";
import PR_NotesTableDropDown from "./Reducers/ReportStage/NotesTableDropdown/index";

import SpecificRowNote from "./Reducers/ReportStage/SpecificRowNote/index"
import FindOutAward from "./Reducers/FindOutAward";

import OneSpecificRowNote from "./Reducers/ReportStage/SpecificRowNote/index";

import DirectCostsComments from './Reducers/ReportStage/DirectCostsComments/index'
import TechnicalReportsRequired from './Reducers/ReportStage/TechnicalReportsRequired'

export default configureStore({
  reducer: {
    UserInfo: UserInfoSlice,
    dropDownApplicationInformation: DropDownApplicationInformation,

    refreshTableStatus: VariousVariables,
    ApplicationInformation: ApplicationInformation,
    PersonalInformation: PersonalInformation,
    SubSectors: SecondarySectors,
    BeneficiaryInformation: BeneficiaryInformation,
    GeneralInformation: GeneralInformation,
    AI_Co_ApplicantNamesData: CoApplicantNames,
    FetchDataJson: FetchDataJson,

    AdvertisingAndMediaPlan: AP_AdvertisingPlan,
    Attachments: Attachments,

    ProjectInformation: ProjectInformation,
    ExpectedProjectImpact: ExpectedProjectImpact,
    SectoreInformationProject: SectoreInformationProject,
    ProjectPlanDetails: ProjectPlanDetails,
    AdvertisingAndMediaPlanForTheProject: AdvertisingAndMediaPlanForTheProject,
    DropDownItem: DropDownItem,
    TargetInfo: TargetInfo,
    OneAdvertisingAndMediaPlanForTheProject:
      OneAdvertisingAndMediaPlanForTheProject,

    Acknowledgement: Acknowledgement,
    ApplicationInformationValidationPage: ApplicationInformationValidationPage,

    ValidateAllPages: ValidateAllPages,

    BI_TimelineInformation: BI_TimelineInformation,

    DropDownTargetedGroupAge: DropDownTargetedGroupAge,
    OneInformationAboutTheTargetGroupOfTheProject:
      OneInformationAboutTheTargetGroupOfTheProject,
    DropDownTETypeOfWork: DropDownTETypeOfWork,
    DropDownTENatureOfWork: DropDownTENatureOfWork,
    TeamMembersPreviousExperiencePartnerships:
      TeamMembersPreviousExperiencePartnerships,
    OneProjectManagementTeamMembers: OneProjectManagementTeamMembers,
    OneExperienceSummary: OneExperienceSummary,
    DropDownNatureOfSupport: DropDownNatureOfSupport,
    OneOtherProjectSupport: OneOtherProjectSupport,
    OneProjectTechnicalTeamMembers: OneProjectTechnicalTeamMembers,
    DropDownTE_TT_TypeOfWork: DropDownTE_TT_TypeOfWork,
    DropDownJordanianGovernoratesName: DropDownJordanianGovernoratesName,
    DropDownPalestinianGovernoratesName: DropDownPalestinianGovernoratesName,
    OnePalestinianGovernoratesProjectActivities:
      OnePalestinianGovernoratesProjectActivities,
    OneJordanianGovernoratesProjectActivitiesData:
      OneJordanianGovernoratesProjectActivitiesData,
    objectives: ObjectivesReducer,
    ObjectivesActivities: ObjectivesActivitiesReducer,
    directCosts: DirectCostsReducer,
    administrativeCosts: AdministrativeCostsReducer,
    BudgetDetails: BudgetDetails,
    ValidationBudget: ValidationBudgetreducer,
    Login: Login,
    TasksManager: TasksManager,
    MarksManager: MarksManager,
    YesNoManager: YesNoManager,
    RecommendationEvaluationManager: RecommendationEvaluationManager,
    FlowSubmitter: FlowSubmitter,
    OneComponentByFlow: OneComponentByFlow,
    ActionButtons: ActionButtons,
    WorkFlowSteps: WorkFlowSteps,
    AccountUserAssigning: AccountUserAssigning,
    SubTaskFlow: SubTaskFlow,
    HeaderTaskPageData: HeaderTaskPageData,
    RoleByUserGuid: RoleByUserGuid,
    AllSubTaskByMain: AllSubTaskByMain,
    StepsAction: StepsAction,
    ValidationTasksManager: ValidationTasksManager,
    JobOpportunitiesDuringProject: JobOpportunitiesDuringProject,
    TypeOfJobOpportunityDropDown: TypeOfJobOpportunityDropDown,

    OpportunitiesObtained: OpportunitiesObtained,
    ChallengesEncounteredThatAffected: ChallengesEncounteredThatAffected,
    SuccessStory: SuccessStory,
    PR_CityDropDown: PR_CityDropDown,
    PR_TypeOfActivityDropDown: PR_TypeOfActivityDropDown,
    PR_AgeGroupDropDown: PR_AgeGroupDropDown,
    PR_NationalityDropDown: PR_NationalityDropDown,
    EventsActivitiesNextFlow: EventsActivitiesNextFlow,
    EventsActivities: EventsActivities,

    REDInformationAboutApplication: InformationAboutApplication,
    ReportByAppGuidReducers: GetReportByAppGuidReducers,
    ObjectiveReducer: Objective,
    Stages: Stages,

    ExpectedObjectivesForStage: ExpectedObjectivesForStage,
    ValidateReportStage: ValidateReportStage,
    LessonsLearned: LessonsLearned,

    InformationSocialMedia: InformationSocialMedia,
    InformationWebsite: InformationWebsite,
    InformationApp: InformationApp,

    WorkFlowReducer: WorkFlowReducer,

    TransferItemInformation: TransferItemInformation,
    TransferDropDowns: TransferDropDowns,

    TechnicalReportNotes: TechnicalReportNotes,
    PR_NotesTableDropDown: PR_NotesTableDropDown,

    SpecificRowNote: SpecificRowNote,
    FindOutAward:FindOutAward,


    WorkFlowReducer:WorkFlowReducer,
    ExchangeInformationItemAdministrativeCostsReducer:ExchangeInformationItemAdministrativeCostsReducer,
    PRAdministrativeCostsReducers:PRAdministrativeCostsReducers,
    ExchangeDirectCostReducers:ExchangeDirectCostReducers,
    ImplementationStagesAndActivitiesReducers:ImplementationStagesAndActivitiesReducers,
    AdministrativeCostsComments:AdministrativeCostsComments,


    OneSpecificRowNote: OneSpecificRowNote,

    DirectCostsComments:DirectCostsComments,
    TechnicalReportsRequired:TechnicalReportsRequired
  },
  devTools: true,
});
